<template>
    <div>
        <breadCrumb 
            :icon="'fa-cog'"
            :category="$t(`sideNav.navSalonSetting`)"
            :subCategory="$t(`subMenu.salon_setting_setup`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 pb-4">
                    <div class="row w-100">
                        <div class="col-sm-12 col-md-4"> 
                            <div class="form-group d-flex">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect  v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                        <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <form @submit.prevent="submitSetup">
                            <h4 class="text-dark fw-500 pb-1 mb-3 border-bottom"> 
                                <i class="fas fa-store-alt mr-2"></i>
                                {{$t('outlet_setting.setup.header_shop')}}
                            </h4>
                            <div v-for="o in outletSetup.slice(0,3)" :key="o.id" class="custom-control custom-switch mb-2">
                                <input type="checkbox" class="custom-control-input" :id="o.id" v-model="o.value">
                                <label class="custom-control-label" :for="o.id">{{o.text}}</label>
                            </div>
                            <h4 class="text-dark fw-500 pb-1 mt-4 mb-3 border-bottom"> 
                                <i class="fas fa-users mr-2"></i>
                               {{$t('outlet_setting.setup.header_member')}}
                            </h4>
                            <div v-for="o in outletSetup.slice(3,5)" :key="o.id" class="custom-control custom-switch mb-2">
                                <input type="checkbox" class="custom-control-input" :id="o.id" v-model="o.value">
                                <label class="custom-control-label" :for="o.id">{{o.text}}</label>
                            </div>
                            <h4 class="text-dark fw-500 pb-1 mt-4 mb-3 border-bottom"> 
                                <i class="fas fa-phone-laptop mr-2"></i>
                                {{$t('outlet_setting.setup.header_app')}}
                            </h4>
                            <div v-for="o in outletSetup.slice(5,7)" :key="o.id" class="custom-control custom-switch mb-2">
                                <input type="checkbox" class="custom-control-input" :id="o.id" v-model="o.value">
                                <label class="custom-control-label" :for="o.id">{{o.text}}</label>
                            </div>
                            <div class="text-left mt-5 mb-3">
                                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BreadCrumb from './../Bread_Crumb'
import inputGroupList from './../../../assets/js/dashboard/input'
import {handleSessionExpired} from './../../../assets/js/dashboard/dashboard'
export default {
    name: 'outletSetup',
    data(){
        return{
           outlet: [], selectedOutlet: {},
           outletSetup: inputGroupList.outletSetup,
           enableMultiLogin: false, enableManual: false, enablePriceControl: false,
           enableMemberName: false, enableMemberDOB: false,
           enableReceipt: false, enableBooking: false,
        }
    },
    components:{
        BreadCrumb
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.getSetup();
            }
            this.$parent.isModalShow = false;
        },
       filterByOutlet(item){
            this.selectedOutlet = item;
            this.getSetup();
        },
        getSetup(){
            let $vm = this;
            const url = this.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.SETUP;

            $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                var result = response.data.result[0];
                for (var r in result){
                    for(var i = 0; i < $vm.outletSetup.length; i++){
                        var id = $vm.outletSetup[i].id;
                        if(r == id){
                            $vm.outletSetup[i].value = result[r] == 1 ? true : false;
                        }
                    }
                } 
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    this.$parent.setModal(this, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
        submitSetup(){
            let $vm = this
            var data = {};
            for(var i=0; i<this.outletSetup.length; i++){
                data[this.outletSetup[i].id] = this.outletSetup[i].value ? 1 : 0
            }
            const url = this.$api.OUTLET + "/" + this.selectedOutlet.id + this.$api.SETUP;
            this.$axios({
                method: 'post', 
                url: url,
                baseURL: this.$axios.defaults.baseURL, 
                headers: {token: this.$util.getSessionToken()},
                data: data
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t(`subMenu.salon_setting_setup`) + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                    $vm.$parent.setModal(this, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    $vm.$parent.setModal($vm, true, true, $vm.$i18n.t('message.error.system_error'));
                }
            })
        },
    },mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.getSetup()  
    }
}
</script>

<style scoped>
.img-input-group{
    padding: 0.5rem 0.65rem;
}
.img-social{
    width: 1.5em;
}
</style>